import React from 'react';
import { translate } from 'react-i18next';
import LoadInline from '../loading/LoadInline.js';
import moment from 'moment';
import { Feed, Icon, Button, Label } from 'semantic-ui-react';
import {colors, spacings, fontSizes, fonts, shadow} from 'style';

var style = {
    dateLabel: {
        width: '3em'
    },
    date: {
        fontSize: '1em',
        marginLeft: spacings.base
    },
    rightFloatDate: {
        position: 'absolute',
        top: spacings.small,
        right: spacings.small,
    },
    item: {
        overflow: 'hidden',
        ...fonts.body,
        lineHeight: '1.5',
        position: 'relative',
        border: '1px solid ' + colors.themeDarkGrey,
        borderRadius: '10px',
        paddingTop: spacings.base,
        paddingRight: '0',
        paddingLeft: '0',
        paddingBottom: spacings.base,
        marginTop: spacings.small,
        marginBottom: spacings.small,
    },
    title: {
        fontSize: '1.5em',
    },
    normalText: {
        color: colors.themeBlue,
    },
    activeText: {
        color: '#fff',
    },
    eventActive: {
        backgroundColor:colors.themeTeal,
        color: '#fff',
    },
    points: {
        width: '100%', 
        height:'32px',
        ...fonts.body,
        lineHeight: '1.5',
    },
    label: {
        textAlign: 'right',
        color: '#fff',
        backgroundColor: colors.themeBlue,
        fontWeight: 'normal',
        position: 'relative',
        minWidth: '80px', 
        paddingRight: '20px',
        borderRadius: '100px',
    },
    pointsLabel: {
        backgroundColor: colors.pointsYellow,
    },
    starIcon: {
        position: 'absolute',
        left: '6px',
        top: '6px',
        fontSize: '1.5em',
        opacity: '1',
        color: '#FFF'
    },
    resourceIcon: {
        position: 'absolute',
        left: '6px',
        top: '6px',
        fontSize: '1.3em',
        opacity: '1',
        color: '#FFF'
    },
    icon: {
        backgroundColor: '#fff',
        color: colors.themeBlue,
        borderRadius: '50%',
        width: '60px',
        height: '60px',
        margin: '5px',
        fontSize: fontSizes.h2,
        position: 'absolute',
        top: '50%',
        marginTop: '-30px',
    },
    iconArea: {
        position: 'absolute',
        top: '0px',
        display: 'inline-block',
        width:'100px', 
        height:'100%', 
        lineHeight:'60px', 
        paddingLeft: spacings.small,
    },
    textArea: {
        verticalAlign: 'top',
        display: 'inline-block',
        lineHeight: '1.5',
        paddingLeft: '120px',
        paddingRight: '190px',
    },
    buttonArea: {
        position: 'absolute',
        top: '0px',
        right: spacings.small,
        display: 'inline-block',
        width: '170px',
        height: '100%',
        lineHeight: '40px',
    },
    button: {
        fontWeight: 'normal',
        backgroundColor: colors.themeBlue,
        color: '#fff',
        borderRadius: '100px',
        width: '100%',
        textAlign: 'center',
        boxShadow: shadow,
        display: 'block',
        position: 'relative',
        top: '50%',
        marginTop: '-25px',
        ...fonts.body,
        lineHeight: '1.5',
    },
    message: {
        fontWeight: 'normal',
        color: '#fff',
        margin: '0',
        borderRadius: '100px',
        width: '100%',
        textAlign: 'center',
        padding: '0 0 0 0',
        border: 'none',
        boxShadow: 'none',
        display: 'block',
        position: 'relative',
        top: '50%',
        marginTop: '-25px',
        ...fonts.body,
        lineHeight: '1.5',
        padding: '.78571429em 1.5em .78571429em',
    },
    messageDone: {
        border: '1px solid #fff',
        backgroundColor: 'rgba(0,0,0,0)',
        color: '#fff',
    },
    messageDoneOld: {
        border: '1px solid ' + colors.themeBlue,
        backgroundColor: 'rgba(0,0,0,0)',
        color: colors.themeBlue,
    },
    messageExpired: {
        backgroundColor: colors.themeDarkerGrey,
        color: '#fff',
    },
}

const AnnouncementsFeedItem = ({t, announcement, isNew, isExpired, getIcon, complete}) => (
        <div style={style.item}>
            <div style={{...style.iconArea, ...(isNew(announcement) ? style.eventActive : {})}} className='announcements-iconArea'>
                <Icon style={style.icon} className={getIcon(announcement)} />
            </div>
            <div style={style.textArea} className='announcements-textArea'>
                <div style={{...style.title, ...style.normalText}} className='announcements-itemTitle'>
                    {announcement.title} 
                </div>
                {announcement.description}
                {announcement.type == 2 && announcement.startsAt &&
                <div>
                    <div className="inlineBlock" style={{...style.dateLabel, ...style.normalText}}>{t('Start:')} </div><div style={{...style.date, ...style.normalText}} className="inline">{moment(announcement.startsAt).format('MMM D, YYYY')} at {moment(announcement.startsAt).format('h:mm a')}</div>
                </div>
                }
                {announcement.type ==2 && announcement.expiresAt &&
                <div>
                    <div className="inlineBlock" style={{...style.dateLabel, ...style.normalText}} style = {(isExpired(announcement) ? {color:colors.warningRed} : {color:colors.themeBlue})}>{isExpired(announcement) ? t('Expired') : t('Expires')} </div><div style={{...style.date, ...(isExpired(announcement) ? {color:colors.warningRed} : {color:colors.themeBlue})}} className="inline">{moment(announcement.expiresAt).format('MMM D, YYYY')} at {moment(announcement.expiresAt).format('h:mm a')}</div>
                </div>
                }
                {announcement.type == 2 &&
                <div>
                    {announcement.challenge && announcement.challenge.points>0 &&
                        <div style={style.points}><Label style={{...style.label, ...style.pointsLabel}} size='large'><span style={{width:'20px'}}>+<Icon style={style.starIcon} className="notClickable icon-star"/></span><span className="bold"> </span><span className="right floated">{announcement.challenge.points}</span></Label></div>
                    }
                    {announcement.challenge && announcement.challenge.resources>0 &&
                        <div style={style.points}><Label style={style.label} size='large'><span style={{width:'20px'}}>+<Icon style={style.resourceIcon} className="notClickable icon-Optimollar"/></span><span className="bold"> </span><span className="right floated">{announcement.challenge && announcement.challenge.resources}</span></Label></div>
                    }
                </div>
                }
            </div>
            <div style={style.buttonArea} className='announcements-buttonArea'>
                <div style={{...style.date, ...style.normalText, ...style.rightFloatDate}}>{moment(announcement.sentAt).format('MMM D')}</div> 
                {announcement.type == 2 &&
                    <div className='full-height'>
                        {Boolean(announcement.userChallenge && announcement.userChallenge.state==1) &&
                            <div style={{...style.message, ...style.messageDoneOld}}>{t('Done')}</div>
                        }
                        {!isExpired(announcement) && (!announcement.userChallenge || announcement.userChallenge.state==0) &&
                            <Button style={style.button} onClick={()=>complete(announcement)}>{t('Done?')}</Button>
                        }
                    </div>
                }
            </div>
        </div>
);


export default translate('newsfeed')(AnnouncementsFeedItem);



// WEBPACK FOOTER //
// ./src/modules/newsfeed/AnnouncementsFeedItem.js